/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
} from './ApiUser';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface ScreenerAnalysisOverride
 */
export interface ScreenerAnalysisOverride {
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    organization_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    screener_analysis_result_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    created_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    override_criteria_result: ScreenerAnalysisOverrideOverrideCriteriaResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    override_reason: ScreenerAnalysisOverrideOverrideReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    override_comment: string;
    /**
     * 
     * @type {CriteriaQualifier}
     * @memberof ScreenerAnalysisOverride
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenerAnalysisOverride
     */
    is_medication_rule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenerAnalysisOverride
     */
    is_revert: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerAnalysisOverride
     */
    updatedAt?: string;
    /**
     * 
     * @type {ApiUser}
     * @memberof ScreenerAnalysisOverride
     */
    created_by_user?: ApiUser;
}


/**
 * @export
 */
export const ScreenerAnalysisOverrideOverrideCriteriaResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
    NA: 'N/A'
} as const;
export type ScreenerAnalysisOverrideOverrideCriteriaResultEnum = typeof ScreenerAnalysisOverrideOverrideCriteriaResultEnum[keyof typeof ScreenerAnalysisOverrideOverrideCriteriaResultEnum];

/**
 * @export
 */
export const ScreenerAnalysisOverrideOverrideReasonEnum = {
    IncompleteOrMissingPatientData: 'Incomplete or missing patient data',
    NewInformationReceived: 'New information received',
    AiReasoningIssues: 'AI reasoning issues',
    AiExtractionOrReadingError: 'AI extraction or reading error',
    ClinicalJudgmentDiffers: 'Clinical judgment differs'
} as const;
export type ScreenerAnalysisOverrideOverrideReasonEnum = typeof ScreenerAnalysisOverrideOverrideReasonEnum[keyof typeof ScreenerAnalysisOverrideOverrideReasonEnum];


/**
 * Check if a given object implements the ScreenerAnalysisOverride interface.
 */
export function instanceOfScreenerAnalysisOverride(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "screener_analysis_result_id" in value;
    isInstance = isInstance && "created_by_user_id" in value;
    isInstance = isInstance && "override_criteria_result" in value;
    isInstance = isInstance && "override_reason" in value;
    isInstance = isInstance && "override_comment" in value;
    isInstance = isInstance && "qualifier" in value;
    isInstance = isInstance && "is_medication_rule" in value;
    isInstance = isInstance && "is_revert" in value;

    return isInstance;
}

export function ScreenerAnalysisOverrideFromJSON(json: any): ScreenerAnalysisOverride {
    return ScreenerAnalysisOverrideFromJSONTyped(json, false);
}

export function ScreenerAnalysisOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerAnalysisOverride {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'screener_analysis_result_id': json['screener_analysis_result_id'],
        'created_by_user_id': json['created_by_user_id'],
        'override_criteria_result': json['override_criteria_result'],
        'override_reason': json['override_reason'],
        'override_comment': json['override_comment'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'is_medication_rule': json['is_medication_rule'],
        'is_revert': json['is_revert'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : ApiUserFromJSON(json['created_by_user']),
    };
}

export function ScreenerAnalysisOverrideToJSON(value?: ScreenerAnalysisOverride | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organization_id,
        'screener_analysis_result_id': value.screener_analysis_result_id,
        'created_by_user_id': value.created_by_user_id,
        'override_criteria_result': value.override_criteria_result,
        'override_reason': value.override_reason,
        'override_comment': value.override_comment,
        'qualifier': CriteriaQualifierToJSON(value.qualifier),
        'is_medication_rule': value.is_medication_rule,
        'is_revert': value.is_revert,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'created_by_user': ApiUserToJSON(value.created_by_user),
    };
}

